<template>
  <b-nav-item-dropdown
    id="tenant-nav-dropdown"
    :text="currentTenant.name"
    toggle-class="nav-link-custom"
    v-if="$route.name == 'home' && currentTenants.length > 0"
  >
    <b-dropdown-item
      v-for="tenant in currentTenants"
      :key="tenant.index"
      @click="handleChangeTenant(tenant.index)"
    >
      {{ tenant.name }}
    </b-dropdown-item>
  </b-nav-item-dropdown>
  <b-nav-text v-else class="tenant-title">
    {{ currentTenant.name }}
  </b-nav-text>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TenantDropdown',
  computed: {
    ...mapGetters('auth', ['currentTenants', 'currentTenant'])
  },
  methods: {
    async handleChangeTenant(index) {
      await this.$store.dispatch('auth/SET_TENANT', index);
    }
  }
};
</script>

<style lang="scss">
.nav {
  a {
    color: #4d4d4f;
  }
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #4d4d4f;
  background-color: unset;
}

.tenant-title {
  flex-grow: 1;
  color: #4d4d4f;
  margin-bottom: unset;
  background-color: #94c62a;
}

#tenant-nav-dropdown {
  min-width: 160px;
}
</style>
